export default "__VITE_ASSET__3Kk7LrFo__"